export default (opts = {}) => {
    const component = {
     model: {
      defaults: {
        type:'div', 
        name: 'Seção Produtos',
        attributes: { class: 'section bg-cinza' },
        components: [
          {
            type: 'containerProducts2'
          }
        ],
        styles: `
        .section{
            position:relative; 
            with:100vw; 
            padding: 75px 5%; 
          }
        .bg-cinza{
          background: #F9F9F9;
        }
        *{
          font-family: Roboto, Arial, sans-serif;
        }
      `,
       },
    },
    view: {

    },
    }; 
    return component; 
};